import { useMemo } from "react";
import HttpService from "./httpService";
import { useTranslation } from "react-i18next";
const useHttpService = () => {
    const enviromentURL = () => {
        let envURL = "https://api.store.nvidia.com";
        let host = window.location.hostname;
        if (host.split(".")[0] !== "store" && host !== "marketplace.nvidia.com") {
            envURL = `https://${host.split(".")[0].split("-")[0]}-api.store.nvidia.com`;
        }
        if (host.indexOf("localhost") > -1) {
            envURL = "https://dev-api.store.nvidia.com";
        }

        return envURL;
    };
    const API_URL = useMemo(() => enviromentURL(), []);
    const httpService = useMemo(() => new HttpService(API_URL), [API_URL]);
    return httpService;
};
export const useAuth = () => {
    const httpService = useHttpService();
    const { t } = useTranslation();

    const InvalidateCheckoutSession = async (handleSuccess: (result: any) => void, handleError: () => void) => {
        try {
            const headerObj = { "X-nvlogin": "true" };
            const result = await httpService.post("/ucc-software/v2/auth/logout", '', headerObj);
            if (result) {
                handleSuccess(result);
            }
        } catch (error) {
            console.error(error);
            handleError();
        }
    }

    const LogoutUser = async (handleLogoutSuccess: (result: any) => void, handleLogoutError: () => void) => {
        try {
            const headerObj = { "X-nvlogin": "true" };
            const result = await httpService.post("/ucc-software/v2/auth/logout?sso=true", '', headerObj);
            if (result) {
                handleLogoutSuccess(result);
            }
        } catch (error) {
            console.error(error);
            handleLogoutError();
        }
    }

    const HandleSSOLogin = async (handleSubmit: (userType: string) => void,
        handleError: (e: string) => void) => {
        try {
            const headerObj = { "X-nvlogin": "true" };
            const result = await httpService.post("/ucc-software/v2/auth/sso-login", '', headerObj);
            if (result) {
                handleSubmit('loggedIn')
            } else {
                console.error("Login Failed");
            }
        } catch (error) {
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
            console.error("Login Error:", error);
        }
    }

    return { LogoutUser, InvalidateCheckoutSession, HandleSSOLogin };
}